<template>
  <div>
    <button
      class="text-gray-700 hover:text-gray-900 text-2xl mr-4"
      @click="desktopSize"
    >
      <FontAwesomeIcon icon="desktop" />
      <p class="text-xxs">
        2850x1000
      </p>
    </button>
    <button
      class="text-gray-700 hover:text-gray-900 text-2xl  mr-4"
      @click="tabletSize"
    >
      <FontAwesomeIcon icon="tablet-alt" />
      <p class="text-xxs">
        1535x1000
      </p>
    </button>
    <button
      class="text-gray-700 hover:text-gray-900 text-2xl  mr-4"
      @click="mobileSize"
    >
      <FontAwesomeIcon icon="mobile-alt" />
      <p class="text-xxs">
        750x500
      </p>
    </button>
  </div>
</template>
<script>
export default {
  name: 'ScreenSizePicker',
  props: {},
  emits: ['tablet', 'mobile', 'desktop'],
  data() {
    return {}
  },
  methods: {
    tabletSize() {
      this.$emit('tablet', 'tablet')
    },
    mobileSize() {
      this.$emit('mobile', 'mobile')
    },
    desktopSize() {
      this.$emit('desktop', 'desktop')
    }
  }
}
</script>
<style scoped></style>
